import React from "react";
import { Typography, Divider } from "antd";

const { Title, Paragraph, Text } = Typography;

const LegalPage = ({ content }) => {
  const renderContact = (contact) => {
    if (!contact) return null;

    return (
      <Paragraph>
        {contact.name && (
          <>
            <Text strong>{contact.name}</Text>
            <br />
          </>
        )}

        {contact.role && (
          <>
            {contact.role}
            <br />
          </>
        )}

        {contact.address?.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}

        {contact.phone && (
          <>
            Telefon: {contact.phone}
            <br />
          </>
        )}

        {contact.email && <>E-Mail: {contact.email}</>}
      </Paragraph>
    );
  };

  return (
    <main className="legal-page">
      <Title level={1}>{content.title}</Title>

      {content.sections.map((section, index) => (
        <section key={index} className="legal-section">
          <Title level={2}>{section.title}</Title>

          {section.paragraphs?.map((paragraph, i) => (
            <Paragraph key={i}>{paragraph}</Paragraph>
          ))}

          {section.contact && renderContact(section.contact)}

          {section.paragraphsAfter?.map((paragraph, i) => (
            <Paragraph key={i}>{paragraph}</Paragraph>
          ))}

          {section.subsections?.map((subsection, i) => (
            <div key={i} className="legal-subsection">
              <Title level={3}>{subsection.title}</Title>

              {subsection.paragraphs?.map((paragraph, j) => (
                <Paragraph key={j}>{paragraph}</Paragraph>
              ))}

              {subsection.items && (
                <ul>
                  {subsection.items.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          {section.items && (
            <ul>
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}

          {index < content.sections.length - 1 && <Divider />}
        </section>
      ))}
    </main>
  );
};

export default LegalPage;